// extracted by mini-css-extract-plugin
module.exports = {"root":"home-intro-module--root--1gORH","text_line":"home-intro-module--text_line--1zQo8","copy":"home-intro-module--copy--1Eb93"};